<div class="container">
  <mat-card-content>
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutGap="10">
          <p>Serial Number:</p>
          <p>{{data.serialnumber}}</p>
        </div>
        <div fxLayout="row" fxLayoutGap="10">
          <p class="heading">Date:</p>
          <p>{{data.date}}</p>
        </div>
        <div fxLayout="row" fxLayoutGap="10">
          <p class="heading">Total Logs:</p>
          <p>{{data.count}}</p>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="10">
        <button mat-icon-button class="copy-icon" matTooltip="Copy" (click)="onCopyClick()">
          <mat-icon>content_copy</mat-icon>
        </button>
        <button mat-icon-button class="close-icon" matTooltip="Close" aria-label="Close" (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <pre class="content-wrapper">{{data.type}}</pre>
  </mat-card-content>
  </div>
  